<template>
	<div>
		<vButtonGroup>
			<Button type="primary" @click="addPart" class="margin-right-5">添加子部门</Button>
			<Button @click="removeParts" class="margin-right-5">批量删除</Button>
			<Button @click="exportParts">批量导出</Button>
		</vButtonGroup>
		<vTableSimple
			class="margin-top-10"
			:columns="columns"
			:data="childrenDeptList"
			@on-check-change="handleChecked"
		></vTableSimple>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <!-- 公共弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" @on-close="closemodalprops"></component>
        </compModal>
	</div>
</template>

<script>
import compAddDept from './adddept.vue'
import mixin from '../mixins'
import { HttpBatchDeleteDept } from '@/service/department/departmentmanage.js'

export default {
    props:["cuttentDepartment","deptList1"],
    mixins: [ mixin ],
    components: {
        compAddDept,
	},
	data() {
		return {
			loading: false,
			childrenDeptList: [],
            selectedDept: [],
            modalProps:{},
            deptList: [],
		}
	},
	created() {
	},
	watch: {
        "deptList1": {
            immediate: true,
            handler (val) {
                this.deptList = val
                this.getChildrenDept(this.cuttentDepartment)
            },
        },
        "cuttentDepartment": {
            immediate: true,
            handler (val) {
                this.getChildrenDept(val)
            }
        },
	},
	computed: {
		columns() {
			return [{
				type: 'selection',
				formName: 'id',
				width: 60
			},
            {
				title: "No.",
				type: 'index',
				width: 120
			},
            {
				title: "部门",
				key: "name",
			}]
		},
	},
	methods: {
        getChildrenDept(val){
            this.childrenDeptList = this.deptList1.filter(item => item.parentId === val) || [];
        },
        addPart(){
            this.modalProps = {
                show: true,
                title:'添加部门',
                width: 460,
                component: "compAddDept",
                showFooter:false,
                selectDeptId:this.cuttentDepartment,
                deptList: this.deptList,
                type: 'add',
                on:{
                    'on-update':()=>{
                        this.update()
                    },
                    'on-close':()=>{
                        this.closemodalprops
                    }
                }
            };
        },
        update(){
            this.$emit('on-update');
        },
        closemodalprops(){
            this.modalProps = {}
        },
        handleChecked (selection) {
            let array = []
            selection.map(item=>{
                array.push(item.id)
            })
            this.selectedDept = array
        },
        removeParts(){
            if(this.selectedDept.length === 0){
                this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                return
            }
            this.modalProps = {
                show: true,
                alert: "error",
                title: "删除",
                width: 460,
                desc:"一旦删除，数据不可恢复，请谨慎操作。",
                params: { ids: this.selectedDept.join(',') },
                ajaxRequest: HttpBatchDeleteDept,
                callback: () => {
                    this.loading = false
                    this.$Message.success({content: '删除成功', duration: 10, closable: true})
                    this.update()
                    this.selectedDept=[]
                },
            };
        },
        exportParts(){
            // if(this.selectedDept.length === 0){
            //     this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            //     return
            // }
            this.handleWebfs(process.env.VUE_APP_APIURL_UC + '/api/v1/UcDepartment/batchExport',{id:this.cuttentDepartment},'download');
        },
	}
}
</script>
